(function () {
  "use strict";

  var isProductPage = /\/products\//.test(window.location.pathname);
  if (window.__lfReviewsWidgetLoaded) return;
  window.__lfReviewsWidgetLoaded = true;

  var API_BASE = window.__LF_REVIEWS_API_BASE || "";
  var SUBMIT_URL = window.__LF_REVIEWS_SUBMIT_URL || "";
  var STORE_KEY = "LF";
  var MAX_REVIEW_PHOTOS = 3;
  var MAX_REVIEW_PHOTO_SIZE = 4 * 1024 * 1024;
  var productHandle = isProductPage ? (window.location.pathname.split("/products/")[1] || "").split("?")[0].split("#")[0] : "";
  ensureWidgetStyles();

  var BOOTSTRAP_DATA = normalizeBootstrap(window.__LF_REVIEWS_BOOTSTRAP || null);

  function createNode(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof text === "string") node.textContent = text;
    return node;
  }

  function stars(rating) {
    var safe = Math.max(0, Math.min(5, Number(rating || 0)));
    var full = Math.round(safe);
    var html = "";
    for (var i = 1; i <= 5; i += 1) {
      html += '<span class="lf-review-star' + (i <= full ? " is-on" : "") + '">★</span>';
    }
    return html;
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function ensureWidgetStyles() {
    if (document.getElementById("lf-reviews-widget-runtime-style")) return;
    var style = document.createElement("style");
    style.id = "lf-reviews-widget-runtime-style";
    style.textContent = [
      ".lf-review-summary-inline{display:grid;gap:10px;margin:18px 0 10px;padding:16px 18px;border:1px solid rgba(15,118,110,.14);border-radius:18px;background:linear-gradient(135deg,#fff 0%,#fbf8f1 64%,#eef8f6 100%);box-shadow:0 8px 24px rgba(0,0,0,.035)}",
      ".lf-review-summary-main{display:grid;grid-template-columns:auto 1fr;align-items:center;gap:14px}.lf-review-summary-score{font-size:32px;line-height:1;font-weight:650;color:#0f766e;letter-spacing:-.03em}.lf-review-summary-copy{display:grid;gap:3px}.lf-review-summary-title{font-size:14px;font-weight:650;color:#111}.lf-review-stars{color:#0f766e;letter-spacing:1px}.lf-review-star{opacity:.25}.lf-review-star.is-on{opacity:1}",
      ".lf-review-summary-text,.lf-review-summary-sitewide,.lf-review-date,.lf-review-form-note,.lf-review-section-caption{color:rgba(0,0,0,.68);font-size:13px}.lf-review-summary-sitewide{border-top:1px solid rgba(15,118,110,.1);padding-top:10px;line-height:1.45}.lf-review-open-button,.lf-review-submit,.lf-review-load-more-button{appearance:none;border:none;border-radius:999px;padding:11px 16px;background:#0f766e;color:#fff;font:inherit;cursor:pointer}.lf-review-open-button:hover,.lf-review-submit:hover,.lf-review-load-more-button:hover{background:#0b5f59}.lf-review-submit[disabled]{opacity:.55;cursor:not-allowed;background:#8a9a97}",
      ".lf-reviews-host{margin:44px auto;max-width:1200px;padding:0 20px}.lf-reviews-header{display:flex;justify-content:space-between;gap:18px;align-items:flex-end;margin-bottom:22px}.lf-reviews-eyebrow{text-transform:uppercase;letter-spacing:.12em;font-size:11px;color:#0f766e;margin:0 0 6px}.lf-reviews-title{margin:0;font-size:31px;line-height:1.05}.lf-reviews-subtitle{margin:0;font-size:18px}.lf-reviews-stack{display:grid;gap:28px}.lf-review-section-block{display:grid;gap:14px}.lf-review-section-head{display:flex;justify-content:space-between;gap:16px;align-items:flex-end}.lf-review-section-caption{margin:6px 0 0;line-height:1.5;max-width:760px}",
      ".lf-review-cards{display:grid;gap:14px}.lf-review-cards-product{grid-template-columns:repeat(auto-fit,minmax(280px,1fr))}.lf-review-cards-sitewide{grid-template-columns:repeat(auto-fit,minmax(300px,1fr))}.lf-review-card{padding:18px;border:1px solid rgba(0,0,0,.08);border-radius:18px;background:#fff;box-shadow:0 8px 24px rgba(0,0,0,.04)}.lf-review-card-head{display:flex;justify-content:space-between;gap:12px;align-items:flex-start;margin-bottom:10px}.lf-review-title{margin:0 0 8px;font-size:18px}.lf-review-body{margin:0;color:rgba(0,0,0,.82);line-height:1.65;white-space:pre-line}.lf-review-meta{display:flex;gap:8px;align-items:center;color:rgba(0,0,0,.7);font-size:13px}",
      ".lf-review-media-grid{display:grid;grid-template-columns:repeat(4,minmax(0,72px));gap:8px;margin-top:14px}.lf-review-media-thumb{display:block;aspect-ratio:1;border-radius:12px;overflow:hidden;background:#f6f4ef}.lf-review-media-thumb img{width:100%;height:100%;object-fit:cover}",
      ".lf-review-pill{display:inline-flex;align-items:center;padding:3px 8px;border-radius:999px;background:#ecfdf5;color:#0f766e;font-size:11px;font-weight:600}.lf-review-product-link{margin-top:12px;font-size:13px}.lf-review-product-link a{color:#0f766e}.lf-review-reply{margin-top:12px;padding:12px;border-radius:14px;background:#f7f7f6}.lf-review-reply-label{font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:#0f766e;margin-bottom:6px}",
      ".lf-review-collapsible[hidden]{display:none!important}.lf-review-collapsible{display:grid;gap:14px;margin-top:14px}.lf-review-load-more-wrap{display:flex;justify-content:center;margin-top:18px}.lf-review-load-more-button{min-width:190px;background:#fff;color:#0f766e;border:1px solid rgba(15,118,110,.35)}.lf-review-load-more-button:hover{color:#fff}",
      ".lf-review-empty{display:grid;gap:10px;padding:20px;border:1px dashed rgba(0,0,0,.14);border-radius:18px;background:#fcfcfb;color:rgba(0,0,0,.72)}.lf-review-empty-compact{grid-template-columns:1fr auto;align-items:center;max-width:none;padding:22px 24px}.lf-review-empty-compact div{display:grid;gap:8px}.lf-review-empty-compact span{line-height:1.5}.lf-review-empty strong{color:#111}",
      ".lf-review-modal{position:fixed;inset:0;display:none;z-index:99999}.lf-review-modal.is-open{display:block}.lf-review-modal-backdrop{position:absolute;inset:0;background:rgba(12,17,22,.45);backdrop-filter:blur(4px)}.lf-review-modal-panel{position:relative;z-index:2;max-width:760px;max-height:92vh;overflow:auto;margin:4vh auto;background:#fff;border-radius:24px;padding:34px 42px;box-shadow:0 30px 80px rgba(0,0,0,.18)}.lf-review-modal-close{position:absolute;top:14px;right:14px;background:none;border:none;font-size:26px;cursor:pointer}.lf-review-modal-title{margin:0 0 28px;text-align:center;font-size:32px}",
      ".lf-review-form{display:grid;gap:22px;max-width:640px;margin:0 auto}.lf-review-form label{display:grid;gap:8px;font-size:13px;color:rgba(0,0,0,.72)}.lf-review-form-label,.lf-review-field-centered>span{display:block;text-align:center;font-size:18px;color:rgba(0,0,0,.72);margin-bottom:10px}.lf-review-rating-field{text-align:center}.lf-review-rating-picker{display:flex;justify-content:center;gap:8px}.lf-review-rating-star{appearance:none;border:0;background:transparent;color:#77cdd0;font-size:42px;line-height:1;cursor:pointer;padding:0 2px;transition:transform .15s ease,color .15s ease}.lf-review-rating-star:hover,.lf-review-rating-star:focus{transform:translateY(-1px);outline:none}.lf-review-rating-star.is-active{color:#0f766e}.lf-review-rating-hint{text-align:center;font-size:13px;color:rgba(0,0,0,.55);margin-top:8px}",
      ".lf-review-form input,.lf-review-form textarea{width:100%;border:1px solid rgba(0,0,0,.18);border-radius:28px;padding:16px 18px;font:inherit;background:#fff}.lf-review-form textarea{border-radius:22px;min-height:170px;resize:vertical}.lf-review-form input:focus,.lf-review-form textarea:focus{border-color:#0f766e;box-shadow:0 0 0 3px rgba(15,118,110,.12);outline:none}.lf-review-upload-field{text-align:center}.lf-review-upload-label{display:grid!important;place-items:center;gap:8px;min-height:160px;border:1px dashed rgba(0,0,0,.18);border-radius:22px;background:#fcfcfb;cursor:pointer;padding:24px;color:rgba(0,0,0,.7)}.lf-review-upload-label input{display:none}.lf-review-upload-icon{font-size:34px;line-height:1;color:#777}.lf-review-upload-label strong{font-size:16px;color:#111}.lf-review-upload-label em{font-style:normal;font-size:13px;color:rgba(0,0,0,.55)}.lf-review-upload-label.is-dragging{border-color:#0f766e;background:#effaf8}",
      ".lf-review-upload-files{display:grid;grid-template-columns:repeat(auto-fit,minmax(120px,1fr));gap:10px;margin-top:12px;text-align:left}.lf-review-upload-preview{display:flex;align-items:center;gap:8px;min-width:0;padding:8px;border:1px solid rgba(0,0,0,.08);border-radius:14px;background:#fff;font-size:12px}.lf-review-upload-preview img{width:42px;height:42px;object-fit:cover;border-radius:10px}.lf-review-upload-preview span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.lf-review-upload-error{grid-column:1/-1;color:#b42318;font-size:13px;text-align:center}",
      ".lf-review-hp{position:absolute!important;left:-10000px!important;top:auto!important;width:1px!important;height:1px!important;overflow:hidden!important}",
      ".lf-review-form-row{display:grid;grid-template-columns:1fr 1fr;gap:14px}.lf-review-form-actions{display:flex;justify-content:space-between;gap:16px;align-items:center}.lf-review-form-status{min-height:20px;color:#0f766e;font-size:13px}.lf-review-submit{padding:13px 20px}",
      "@media(max-width:900px){.lf-reviews-header,.lf-review-section-head{display:grid}.lf-review-empty-compact{grid-template-columns:1fr;justify-items:start}.lf-review-form-row{grid-template-columns:1fr}.lf-review-form-actions{display:grid}.lf-review-modal-panel{margin:0;min-height:100vh;max-height:none;border-radius:0;padding:26px 20px}.lf-review-modal-title{font-size:28px}.lf-review-rating-star{font-size:36px}.lf-review-upload-files{grid-template-columns:1fr}}"
    ].join("");
    document.head.appendChild(style);
  }

  function findMount() {
    var judgeme = document.getElementById("judgeme_product_reviews");
    if (judgeme && judgeme.parentNode) return judgeme;
    return document.querySelector("main .container, #MainContent .container, .product-main, main");
  }

  function findSummaryMount() {
    var form = document.querySelector("form[action*='/cart/add']");
    if (!form) return null;
    var buttons = form.querySelector(".product-form__buttons");
    return buttons && buttons.parentNode ? buttons.parentNode : form;
  }

  function hideJudgeMe() {
    Array.prototype.slice.call(document.querySelectorAll(".jdgm-widget, [id*='judgeme'], [class*='jdgm']")).forEach(function (node) {
      node.style.display = "none";
    });
  }

  function normalizeDate(value) {
    if (!value) return "";
    var date = new Date(value);
    if (isNaN(date.getTime())) return "";
    return date.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  }

  function normalizeSummary(value) {
    var source = value && typeof value === "object" ? value : {};
    return {
      average_rating: Number(source.average_rating || 0),
      review_count: Number(source.review_count || 0)
    };
  }

  function normalizeReview(review) {
    if (!review || typeof review !== "object") return null;
    return {
      product_handle: review.product_handle || null,
      product_title: review.product_title || null,
      rating: Number(review.rating || 0),
      title: review.title || null,
      body: review.body || "",
      reviewer_name: review.reviewer_name || "Anonymous",
      verified_purchase: Boolean(review.verified_purchase),
      published_at: review.published_at || null,
      submitted_at: review.submitted_at || null,
      merchant_reply: review.merchant_reply || null,
      merchant_replied_at: review.merchant_replied_at || null,
      sitewide_visible: Boolean(review.sitewide_visible),
      shopify_review_media: Array.isArray(review.shopify_review_media) ? review.shopify_review_media : []
    };
  }

  function normalizeBootstrap(raw) {
    if (!raw || typeof raw !== "object") return null;
    var summary = raw.summary && typeof raw.summary === "object" ? raw.summary : {};
    var reviews = Array.isArray(raw.reviews) ? raw.reviews.map(normalizeReview).filter(Boolean) : [];
    return {
      summary: {
        product: normalizeSummary(summary.product),
        site: normalizeSummary(summary.site)
      },
      reviews: reviews
    };
  }

  function reviewCard(review, currentHandle) {
    var sitewide = review.product_handle && review.product_handle !== currentHandle;
    var media = Array.isArray(review.shopify_review_media) ? review.shopify_review_media : [];
    var imageMedia = media.filter(function (item) { return item && item.media_type !== "video" && item.storage_path; }).slice(0, 4);
    var verified = review.verified_purchase ? '<span class="lf-review-pill">Verified</span>' : "";
    var source = sitewide
      ? '<div class="lf-review-product-link">Loved on <a href="/products/' + escapeHtml(review.product_handle) + '">' + escapeHtml(review.product_title || review.product_handle) + "</a></div>"
      : "";
    var gallery = imageMedia.length
      ? '<div class="lf-review-media-grid">' + imageMedia.map(function (item) {
          return '<a href="' + escapeHtml(item.storage_path) + '" target="_blank" rel="noopener" class="lf-review-media-thumb"><img src="' + escapeHtml(item.storage_path) + '" alt="' + escapeHtml(item.alt_text || "Customer review photo") + '" loading="lazy"></a>';
        }).join("") + "</div>"
      : "";
    var reply = review.merchant_reply
      ? '<div class="lf-review-reply"><div class="lf-review-reply-label">La Foret replied</div><div>' + escapeHtml(review.merchant_reply) + "</div></div>"
      : "";
    return (
      '<article class="lf-review-card">' +
        '<div class="lf-review-card-head">' +
          '<div><div class="lf-review-stars">' + stars(review.rating) + '</div><div class="lf-review-meta"><strong>' + escapeHtml(review.reviewer_name) + "</strong> " + verified + "</div></div>" +
          '<div class="lf-review-date">' + escapeHtml(normalizeDate(review.published_at || review.submitted_at)) + "</div>" +
        "</div>" +
        (review.title ? '<h4 class="lf-review-title">' + escapeHtml(review.title) + "</h4>" : "") +
        '<p class="lf-review-body">' + escapeHtml(review.body) + "</p>" +
        gallery +
        source +
        reply +
      "</article>"
    );
  }

  function ratingPickerHtml() {
    var html = '<div class="lf-review-rating-picker" role="radiogroup" aria-label="Rating">';
    for (var i = 1; i <= 5; i += 1) {
      html += '<button type="button" class="lf-review-rating-star" data-rating="' + i + '" role="radio" aria-checked="false" aria-label="' + i + ' star' + (i === 1 ? "" : "s") + '">☆</button>';
    }
    return html + '</div><input type="hidden" name="rating" required><div class="lf-review-rating-hint">Tap a star to rate your piece.</div>';
  }

  function renderSummary(summaryMount, data) {
    if (!summaryMount || summaryMount.querySelector(".lf-review-summary-inline")) return;
    var product = data.summary && data.summary.product ? data.summary.product : { average_rating: 0, review_count: 0 };
    var site = data.summary && data.summary.site ? data.summary.site : { average_rating: 0, review_count: 0 };
    var productCount = Number(product.review_count || 0);
    var siteCount = Number(site.review_count || 0);
    var hasProductReviews = productCount > 0;
    var displayScore = hasProductReviews ? product.average_rating : site.average_rating;
    var formatRating = function (value) {
      var numeric = Number(value);
      return Number.isFinite(numeric) ? numeric.toFixed(1) : '0.0';
    };
    var displayScoreText = formatRating(displayScore);
    var summaryTitle = hasProductReviews
      ? productCount + " product review" + (productCount === 1 ? "" : "s") + " for this design"
      : "La Foret customer rating";
    var summaryText = hasProductReviews
      ? "Rated by customers who purchased this piece."
      : siteCount + " customer review" + (siteCount === 1 ? "" : "s") + " across La Foret jewelry.";
    var sitewideText = hasProductReviews
      ? "La Foret overall: " + formatRating(site.average_rating) + "/5 from " + siteCount + " customer review" + (siteCount === 1 ? "" : "s") + "."
      : "";
    var wrap = createNode("section", "lf-review-summary-inline");
    wrap.innerHTML =
      '<div class="lf-review-summary-main">' +
        '<div class="lf-review-summary-score">' + escapeHtml(displayScoreText) + "</div>" +
        '<div class="lf-review-summary-copy">' +
          '<div class="lf-review-stars">' + stars(displayScore) + '</div>' +
          '<div class="lf-review-summary-title">' + escapeHtml(summaryTitle) + '</div>' +
          '<div class="lf-review-summary-text">' + escapeHtml(summaryText) + '</div>' +
        "</div>" +
      "</div>" +
      (sitewideText ? '<div class="lf-review-summary-sitewide">' + escapeHtml(sitewideText) + "</div>" : "");
    summaryMount.insertBefore(wrap, summaryMount.firstChild || null);
  }

  function renderSection(mount, data) {
    if (!mount) return;
    mount.innerHTML = "";
    var reviews = Array.isArray(data.reviews) ? data.reviews : [];
    var productReviews = reviews.filter(function (review) { return review.product_handle === productHandle; });
    var sitewideReviews = reviews.filter(function (review) { return review.sitewide_visible && review.product_handle !== productHandle; });
    var visibleSitewideReviews=sitewideReviews,hiddenSitewideReviews=[];
    var productSummary = data.summary && data.summary.product ? data.summary.product : { average_rating: 0, review_count: 0 };

    var section = createNode("section", "lf-reviews-section");
    section.innerHTML =
      '<div class="lf-reviews-header">' +
        '<div>' +
          '<p class="lf-reviews-eyebrow">Customer Reviews</p>' +
          '<h2 class="lf-reviews-title">What customers say about this piece</h2>' +
        '</div>' +
      "</div>";

    var stack = createNode("div", "lf-reviews-stack");

    if (productHandle) {
    var productBlock = createNode("section", "lf-review-section-block lf-review-section-product");
    productBlock.innerHTML =
      '<div class="lf-review-section-head">' +
        '<div>' +
          '<h3 class="lf-reviews-subtitle">Product Reviews</h3>' +
          '<p class="lf-review-section-caption">' +
            (productReviews.length
              ? escapeHtml(String(productSummary.review_count || productReviews.length)) + ' verified impressions for this design.'
              : 'No published reviews yet for this exact design.') +
          '</p>' +
        '</div>' +
      '</div>' +
      (productReviews.length
        ? '<div class="lf-review-cards lf-review-cards-product">' + productReviews.map(function (review) { return reviewCard(review, productHandle); }).join("") + '</div>'
        : '<div class="lf-review-empty lf-review-empty-compact"><div><strong>Be the first reviewer.</strong><span>Share sizing, craftsmanship, gifting, photos, or delivery feedback to help the next shopper buy with confidence.</span></div><button type="button" class="lf-review-open-button">Write the first review</button></div>');

    }

    var sitewideBlock = createNode("section", "lf-review-section-block lf-review-section-sitewide");
    sitewideBlock.innerHTML =
      '<div class="lf-review-section-head">' +
        '<div>' +
          '<h3 class="lf-reviews-subtitle">' + (productHandle ? "Reviews from other La Foret pieces" : "What customers say about La Foret") + '</h3>' +
          '<p class="lf-review-section-caption">' + (productHandle ? "Recent feedback for other La Foret pieces. Product-specific Judge.me reviews appear above when available." : "Recent customer feedback from the La Foret community.") + '</p>' +
        '</div>' +
      '</div>' +
      (sitewideReviews.length
        ? '<div class="lf-review-cards lf-review-cards-sitewide">' + visibleSitewideReviews.map(function (review) { return reviewCard(review, productHandle); }).join("") + '</div>' +
          (hiddenSitewideReviews.length
            ? '<div id="lf-review-sitewide-more" class="lf-review-collapsible" hidden><div class="lf-review-cards lf-review-cards-sitewide">' + hiddenSitewideReviews.map(function (review) { return reviewCard(review, productHandle); }).join("") + '</div></div><div class="lf-review-load-more-wrap"><button type="button" class="lf-review-load-more-button" aria-controls="lf-review-sitewide-more" aria-expanded="false">Load more reviews</button></div>'
            : "")
        : '<div class="lf-review-empty">More customer reviews will appear here as they are featured.</div>');

    stack.appendChild(productBlock);
    stack.appendChild(sitewideBlock);
    section.appendChild(stack);
    mount.appendChild(section);
    wireReviewSectionToggles();
  }

  function wireReviewSectionToggles() {
    Array.prototype.slice.call(document.querySelectorAll(".lf-review-load-more-button")).forEach(function (button) {
      if (button.getAttribute("data-lf-review-toggle-wired") === "true") return;
      button.setAttribute("data-lf-review-toggle-wired", "true");
      button.addEventListener("click", function () {
        var targetId = button.getAttribute("aria-controls");
        var target = targetId ? document.getElementById(targetId) : null;
        if (!target) return;
        var expanded = button.getAttribute("aria-expanded") === "true";
        target.hidden = expanded;
        button.setAttribute("aria-expanded", expanded ? "false" : "true");
        button.textContent = expanded ? "Load more reviews" : "Show fewer reviews";
      });
    });
  }

  function buildModal() {
    if (document.getElementById("lf-review-modal")) return document.getElementById("lf-review-modal");
    var modal = createNode("div", "lf-review-modal");
    modal.id = "lf-review-modal";
    modal.innerHTML =
      '<div class="lf-review-modal-backdrop"></div>' +
      '<div class="lf-review-modal-panel" role="dialog" aria-modal="true" aria-labelledby="lf-review-modal-title">' +
        '<button type="button" class="lf-review-modal-close" aria-label="Close review form">×</button>' +
        '<h3 id="lf-review-modal-title" class="lf-review-modal-title">Write a review</h3>' +
        '<form class="lf-review-form" enctype="multipart/form-data">' +
          '<div class="lf-review-rating-field"><span class="lf-review-form-label">Rating</span>' + ratingPickerHtml() + '</div>' +
          '<label class="lf-review-field-centered"><span>Review Title</span><input name="title" maxlength="120" placeholder="Give your review a title" /></label>' +
          '<label class="lf-review-field-centered"><span>Review content</span><textarea name="body" required maxlength="5000" rows="6" placeholder="Start writing here..."></textarea></label>' +
          '<div class="lf-review-upload-field"><span class="lf-review-form-label">Picture (optional)</span><label class="lf-review-upload-label" for="lf-review-media-input"><input id="lf-review-media-input" type="file" name="media" accept="image/*" multiple><span class="lf-review-upload-icon">↑</span><strong>Add photos</strong><em>Drag photos here or click to upload. Up to 3 images, 4MB each.</em></label><div class="lf-review-upload-files" aria-live="polite"></div></div>' +
          '<div class="lf-review-form-row">' +
            '<label><span>Name</span><input name="reviewer_name" required maxlength="120" placeholder="Display name" /></label>' +
            '<label><span>Email</span><input type="email" name="reviewer_email" required maxlength="190" placeholder="Your email" /></label>' +
          '</div>' +
          '<div class="lf-review-form-row">' +
            '<label><span>City</span><input name="reviewer_city" maxlength="120" placeholder="Optional" /></label>' +
            '<label><span>Country</span><input name="reviewer_country" maxlength="120" placeholder="Optional" /></label>' +
          '</div>' +
          '<label class="lf-review-hp" aria-hidden="true"><span>Website</span><input name="website" tabindex="-1" autocomplete="off"></label>' +
          '<input type="hidden" name="form_started_at">' +
          '<div class="lf-review-form-actions">' +
            '<div class="lf-review-form-note">Reviews are moderated before publication.</div>' +
            '<button type="submit" class="lf-review-submit">Submit review</button>' +
          '</div>' +
          '<div class="lf-review-form-status" aria-live="polite"></div>' +
        '</form>' +
      "</div>";
    document.body.appendChild(modal);
    return modal;
  }

  function wireModal(submitUrl, dataLoader) {
    var modal = buildModal();
    var panel = modal.querySelector(".lf-review-modal-panel");
    var closeButton = modal.querySelector(".lf-review-modal-close");
    var backdrop = modal.querySelector(".lf-review-modal-backdrop");
    var form = modal.querySelector(".lf-review-form");
    var status = modal.querySelector(".lf-review-form-status");
    var submitButton = modal.querySelector(".lf-review-submit");
    var ratingInput = form.querySelector("input[name='rating']");
    var startedAtInput = form.querySelector("input[name='form_started_at']");
    var ratingButtons = Array.prototype.slice.call(modal.querySelectorAll(".lf-review-rating-star"));
    var fileInput = form.querySelector("input[name='media']");
    var uploadLabel = modal.querySelector(".lf-review-upload-label");
    var uploadFiles = modal.querySelector(".lf-review-upload-files");
    var previewUrls = [];

    function selectedFiles() {
      return Array.prototype.slice.call(fileInput && fileInput.files ? fileInput.files : []);
    }

    function paintRating(value) {
      ratingButtons.forEach(function (button) {
        var active = Number(button.getAttribute("data-rating")) <= value;
        button.classList.toggle("is-active", active);
        button.textContent = active ? "★" : "☆";
        button.setAttribute("aria-checked", active && Number(button.getAttribute("data-rating")) === value ? "true" : "false");
      });
    }

    function setRating(value) {
      var rating = Math.max(0, Math.min(5, Number(value || 0)));
      ratingInput.value = rating ? String(rating) : "";
      paintRating(rating);
    }

    function validateFiles(files) {
      if (files.length > MAX_REVIEW_PHOTOS) return "Upload up to " + MAX_REVIEW_PHOTOS + " photos.";
      for (var i = 0; i < files.length; i += 1) {
        if (!/^image\//.test(files[i].type || "")) return "Only image uploads are supported.";
        if (files[i].size > MAX_REVIEW_PHOTO_SIZE) return "Each photo must be 4MB or smaller.";
      }
      return "";
    }

    function clearPreviewUrls() {
      previewUrls.forEach(function (url) { URL.revokeObjectURL(url); });
      previewUrls = [];
    }

    function renderSelectedFiles() {
      var files = selectedFiles();
      clearPreviewUrls();
      uploadFiles.innerHTML = "";
      if (!files.length) return;

      files.slice(0, MAX_REVIEW_PHOTOS).forEach(function (file) {
        var item = createNode("div", "lf-review-upload-preview");
        var image = document.createElement("img");
        var url = URL.createObjectURL(file);
        previewUrls.push(url);
        image.src = url;
        image.alt = file.name || "Selected review photo";
        item.appendChild(image);
        item.appendChild(createNode("span", "", file.name || "Selected photo"));
        uploadFiles.appendChild(item);
      });

      var error = validateFiles(files);
      if (error) uploadFiles.appendChild(createNode("div", "lf-review-upload-error", error));
    }

    function close() { modal.classList.remove("is-open"); }
    function open() {
      status.textContent = "";
      if (!submitUrl) status.textContent = "Review submission is being connected. You can preview the form here, but submissions are not live yet.";
      if (startedAtInput) startedAtInput.value = String(Date.now());
      modal.classList.add("is-open");
      var firstStar = modal.querySelector(".lf-review-rating-star");
      if (firstStar) setTimeout(function () { firstStar.focus(); }, 80);
    }

    window.__lfOpenReviewModal = open;

    if (!document.documentElement.getAttribute("data-lf-review-open-wired")) {
      document.addEventListener("click", function (event) {
        var trigger = event.target && event.target.closest ? event.target.closest(".lf-review-open-button") : null;
        if (!trigger) return;
        event.preventDefault();
        if (typeof window.__lfOpenReviewModal === "function") window.__lfOpenReviewModal();
      });
      document.documentElement.setAttribute("data-lf-review-open-wired", "true");
    }

    if (modal.getAttribute("data-lf-review-modal-wired") === "true") return;
    modal.setAttribute("data-lf-review-modal-wired", "true");
    if (!submitUrl && submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = "Submission not live yet";
    }

    closeButton.addEventListener("click", close);
    backdrop.addEventListener("click", close);

    ratingButtons.forEach(function (button) {
      button.addEventListener("click", function () { setRating(button.getAttribute("data-rating")); });
      button.addEventListener("mouseenter", function () { paintRating(Number(button.getAttribute("data-rating"))); });
      button.addEventListener("focus", function () { paintRating(Number(button.getAttribute("data-rating"))); });
    });
    modal.querySelector(".lf-review-rating-picker").addEventListener("mouseleave", function () {
      paintRating(Number(ratingInput.value || 0));
    });

    if (fileInput) {
      fileInput.addEventListener("change", renderSelectedFiles);
    }

    ["dragenter", "dragover"].forEach(function (eventName) {
      uploadLabel.addEventListener(eventName, function (event) {
        event.preventDefault();
        uploadLabel.classList.add("is-dragging");
      });
    });
    ["dragleave", "drop"].forEach(function (eventName) {
      uploadLabel.addEventListener(eventName, function () {
        uploadLabel.classList.remove("is-dragging");
      });
    });
    uploadLabel.addEventListener("drop", function (event) {
      event.preventDefault();
      if (!event.dataTransfer || !event.dataTransfer.files || !window.DataTransfer) return;
      var transfer = new DataTransfer();
      Array.prototype.slice.call(event.dataTransfer.files).slice(0, MAX_REVIEW_PHOTOS).forEach(function (file) {
        transfer.items.add(file);
      });
      fileInput.files = transfer.files;
      renderSelectedFiles();
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (!submitUrl) {
        status.textContent = "Review submission is being connected. Submissions are not live yet.";
        return;
      }
      if (!ratingInput.value) {
        status.textContent = "Please choose a star rating.";
        paintRating(0);
        return;
      }
      var fileError = validateFiles(selectedFiles());
      if (fileError) {
        status.textContent = fileError;
        return;
      }
      status.textContent = "Submitting review...";
      var payload = new FormData(form);
      payload.set("store_key", STORE_KEY);
      payload.set("review_type", "product");
      payload.set("product_handle", productHandle);
      payload.set("product_title", (document.querySelector("h1") && document.querySelector("h1").textContent || "").trim());
      payload.set("rating", ratingInput.value);

      fetch(submitUrl, {
        method: "POST",
        body: payload,
      })
        .then(function (response) { return response.json().then(function (json) { return { ok: response.ok, json: json }; }); })
        .then(function (result) {
          if (!result.ok) throw new Error(result.json && result.json.error || "Submit failed");
          status.textContent = "Thank you. Your review was submitted for approval.";
          form.reset();
          setRating(0);
          renderSelectedFiles();
          setTimeout(close, 1200);
          if (typeof dataLoader === "function") setTimeout(dataLoader, 800);
        })
        .catch(function (error) {
          status.textContent = error && error.message ? error.message : "Could not submit review.";
        });
    });

    panel.addEventListener("click", function (event) { event.stopPropagation(); });
  }

  function mountReviews(data) {
    var summaryMount = findSummaryMount();
    var mount = findMount();
    if (!mount) return;
    if (summaryMount) renderSummary(summaryMount, data);
    var host = document.querySelector(".lf-reviews-host");
    if (!host) {
      host = createNode("div", "lf-reviews-host");
      mount.parentNode.insertBefore(host, mount.nextSibling);
    }
    renderSection(host, data);
    wireModal(SUBMIT_URL, loadReviews);
  }

  function loadReviews() {
    if (BOOTSTRAP_DATA) {
      mountReviews(BOOTSTRAP_DATA);
      return Promise.resolve(BOOTSTRAP_DATA);
    }
    if (!API_BASE) {
      console.warn("La Foret reviews widget missing Shopify bootstrap and API fallback.");
      return Promise.resolve(null);
    }
    var url = API_BASE + "?store=" + encodeURIComponent(STORE_KEY) + "&product_handle=" + encodeURIComponent(productHandle) + "&include_store_reviews=true&page_size=50&sort=newest";
    return fetch(url, { method: "GET" })
      .then(function (response) { return response.json().then(function (json) { return { ok: response.ok, json: json }; }); })
      .then(function (result) {
        if (!result.ok) throw new Error(result.json && result.json.error || "Failed to load reviews");
        mountReviews(normalizeBootstrap(result.json) || result.json);
      })
      .catch(function (error) {
        console.warn("La Foret reviews widget failed", error);
      });
  }

  /* lf-first-party-direct-photo-upload-v1 */document.addEventListener("submit",function(event){var form=event.target;if(!form||!form.matches||!form.matches(".lf-review-form")||!SUBMIT_URL)return;event.preventDefault(),event.stopImmediatePropagation();var status=form.querySelector(".lf-review-form-status"),submitButton=form.querySelector(".lf-review-submit"),fileInput=form.querySelector("input[name='media']"),files=fileInput&&fileInput.files?Array.prototype.slice.call(fileInput.files):[],originalLabel=submitButton?submitButton.textContent:"Submit review";function parse(response){return response.json().catch(function(){return{}}).then(function(json){return{ok:response.ok,json:json}})}function fail(message){throw new Error(message||"Could not submit review.")}function setBusy(label){if(submitButton){submitButton.disabled=!0,submitButton.textContent=label}if(status)status.textContent=label}function finish(){if(submitButton){submitButton.disabled=!1,submitButton.textContent=originalLabel||"Submit review"}}var payload=new FormData(form);payload.delete("media"),payload.set("media_metadata",JSON.stringify(files.map(function(file){return{name:file.name,type:file.type,size:file.size}}))),payload.set("store_key",STORE_KEY),payload.set("review_type","product"),payload.set("product_handle",productHandle),payload.set("product_title",(document.querySelector("h1")&&document.querySelector("h1").textContent||"").trim()),payload.set("rating",form.querySelector("input[name='rating']").value),setBusy("Submitting review…"),fetch(SUBMIT_URL,{method:"POST",body:payload}).then(parse).then(function(result){if(!result.ok)fail(result.json&&result.json.error);var uploads=Array.isArray(result.json&&result.json.media_uploads)?result.json.media_uploads:[];if(uploads.length!==files.length)fail("Could not prepare all review photos. Please try again.");if(!uploads.length)return result.json;if(status)status.textContent="Uploading review photos…";return Promise.all(uploads.map(function(upload,index){return fetch(upload.signed_url,{method:"PUT",headers:{"content-type":files[index].type,"cache-control":"max-age=31536000","x-upsert":"false"},body:files[index]}).then(function(response){if(!response.ok)fail("Could not upload a review photo. Please try again.")})})).then(function(){return fetch(SUBMIT_URL,{method:"POST",headers:{"content-type":"application/json"},body:JSON.stringify({action:"complete_media",review_id:result.json.review_id,media:uploads.map(function(upload,index){return{path:upload.path,altText:files[index].name}})})}).then(parse)}).then(function(mediaResult){if(!mediaResult.ok)fail(mediaResult.json&&mediaResult.json.error);return result.json})}).then(function(result){if(status)status.textContent=result.message||"Thank you. Your review was submitted for approval.";form.reset();if(fileInput)fileInput.dispatchEvent(new Event("change"));Array.prototype.slice.call(form.querySelectorAll(".lf-review-rating-star")).forEach(function(button){button.classList.remove("is-active"),button.setAttribute("aria-checked","false"),button.textContent="☆"});setTimeout(function(){var modal=form.closest(".lf-review-modal");if(modal)modal.classList.remove("is-open")},1200)}).catch(function(error){if(status)status.textContent=error&&error.message?error.message:"Could not submit review."}).finally(finish)},!0);if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", loadReviews, { once: true });
  } else {
    loadReviews();
  }
})();

/* LF RATING FORMAT V1 */
/* LF SITEWIDE REVIEWS V1 */
/* LF SITEWIDE REVIEWS V2 */
/* lf-judgeme-widget-visible-v1 */
